<!-- eslint-disable vue/no-v-html -->
<template>
  <v-app-bar app clipped-left dense>
    <router-link class="text-capitalize text-decoration-none pr-16" :to="{ name: 'dashboard' }">
      <span class="pl-gradient-colors">
        {{ clientConfig.systemTitleLong }}
      </span>
      <span v-if="clientConfig.systemEnv !== 'prod'" class="system-env text--secondary">
        {{ clientConfig.systemEnv }}
      </span>
    </router-link>

    <v-spacer />

    <!-- notifications -->
    <browser-notification v-if="isLoggedIn" :notification-title="clientConfig.systemTitleLong" />

    <!-- user menu -->
    <v-menu v-if="isLoggedIn" bottom left transition="slide-x-transition">
      <template #activator="{ on, attrs }">
        <v-btn
          class="aurora-keep-case"
          color="primary darken-2"
          data-test-id="user-avatar"
          fab
          v-bind="attrs"
          x-small
          v-on="on"
        >
          {{ nameInitials }}
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-btn class="aurora-keep-case" color="primary darken-2" fab x-large>
              {{ nameInitials }}
            </v-btn>
          </v-list-item-avatar>

          <v-list-item-content v-if="loginState.user !== null">
            <v-list-item-title>
              {{ loginState.user.name }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ loginState.user.companyName }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          data-test-id="user-menu-settings"
          :to="{ name: 'settings', params: { returnPath: currentPath } }"
        >
          <v-list-item-title class="text-capitalize">settings</v-list-item-title>
          <v-list-item-action>
            <v-icon>mdi-settings</v-icon>
          </v-list-item-action>
        </v-list-item>

        <!-- @TODO: some kind of help or documentation ref -->
        <!-- @TODO: temporarily disabled until FAQ content is updated -->
        <!-- <v-list-item @click="showFaqDialog = true">
          <v-list-item-title class="text-capitalize">help</v-list-item-title>
          <v-list-item-action>
            <v-icon>mdi-help</v-icon>
          </v-list-item-action>
        </v-list-item> -->

        <v-list-item data-test-id="user-menu-send-feedback" @click="showFeedbackDialog = true">
          <v-list-item-title class="text-capitalize">send feedback</v-list-item-title>
        </v-list-item>

        <v-divider />

        <v-list-item data-test-id="user-menu-logout" to="/logout">
          <v-list-item-title class="text-capitalize">log out</v-list-item-title>
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- various dialog box popups -->
    <!-- @TODO: temporarily disabled until FAQ content is updated -->
    <!-- <faq-popup v-if="showFaqDialog" v-model="showFaqDialog" /> -->
    <feedback-dialog v-if="showFeedbackDialog" v-model="showFeedbackDialog" />
  </v-app-bar>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { Role } from '@/utils/helpers/permissions';
import { ClientConfig } from '@/utils/helpers/rest';
import BrowserNotification from '@/modules/notifications/components/BrowserNotification.vue';
import { LoginState } from '@/store/store';
import FeedbackDialog from '@/modules/feedback/components/FeedbackDialog.vue';

@Component({
  components: {
    BrowserNotification,
    FeedbackDialog,
  },
  computed: {
    ...mapState(['loginState', 'clientConfig']),
    ...mapGetters(['isLoggedIn']),
  },
})
export default class Header extends Vue {
  // @TODO: temporarily disabled until FAQ content is updated -->
  // protected showFaqDialog = false;
  protected showFeedbackDialog = false;
  protected roles = Role;

  // store state/getters
  protected loginState!: LoginState;
  protected isLoggedIn!: boolean;
  protected clientConfig!: ClientConfig;

  protected get currentPath(): string {
    return this.$route.fullPath;
  }

  protected get nameInitials(): string {
    if (!this.loginState.user) {
      return '';
    }
    return this.getInitials(this.loginState.user.name);
  }

  protected getInitials(name: string): string {
    let nameParts = name.split(' ');

    // don't risk butchering somebody's name if we can't make it fit,
    //  in that case just stick to the first initial.
    if (nameParts.length > 3) {
      nameParts = [nameParts[0]];
    }

    return nameParts.map((namePart) => namePart.substring(0, 1)).join('');
  }
}
</script>

<style lang="scss" scoped>
.system-env {
  text-transform: uppercase;
  margin-top: 2px;
}
</style>
